import { FC } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2DetailGroup from '@/common/components/Feedback/V2DetailItem/Group';
import V2DetailItem from '@/common/components/Feedback/V2DetailItem';

/**
 * 场地概览
 * @description
 * @demo
 */
const PlaceOverview:FC<{ data: any, className?: string }> = ({ data = {}, className }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<V2DetailGroup moduleType='easy' className={cs(styles.placeOverview, className)}>
    <V2DetailItem label='类型' value={data?.type}/>
    <V2DetailItem label='项目定位' value={data?.projectOrientation}/>
    <V2DetailItem label='日均客流' value={data?.dayFlow}/>
    <V2DetailItem label='商业体量' value={data?.mallSize}/>
    <V2DetailItem label='开业时间' value={data?.mallOpenYears}/>
    <V2DetailItem label='项目品牌' value={data?.brand}/>
  </V2DetailGroup>);
};

export default PlaceOverview;
